import React, { useState, useEffect } from 'react';
import { CertificatesTableComponent } from './table/CertificatesTableComponent';
import * as api from 'api/clients/certificates';
import { AutoRefreshTable } from "../../layout/Table/AutoRefreshTable";
import { RowsPerPage } from "../../layout/Table/RowsPerPage";
import { Paginator } from '../../layout/Paginator/Paginator';
import { Search } from '../../layout/Table/Search';
import { store } from '../../../store/store';
import { hideNotification } from '../../../store/actions/notification';
import { hideSpinner, showSpinner } from "../../../store/actions/loading";
import { connect } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { FiltersList } from 'components/shared/filters/FiltersList';
import { useUpdateEffect } from '../../../helpers/hooks';
import { NOTIFICATION_LIST_CERTIFICATES } from '../../../config/notifications';
import { PAGE_CONTEXTS } from '../../../config/constants';
import {
  getCertificateStatusFilterIdentifiers,
  FILTERS,
  FILTERS_NAMES
} from '../../../config/certificate';
import { TRANSLATED_CERTIFICATE_FILTER_STATUSES } from '../../../config/constants';
import { CheckboxFilter } from '../../shared/filters/CheckboxFilter';
import { ListToolbar } from '../../layout/Workspace';
import { FormattedMessage } from 'react-intl';

const Certificates = (props) => {
  const history = useHistory();
  const location = useLocation();
  const [ sortDirection, setSortDirection ] = useState( null );
  const [ sortField, setSortField ] = useState( null );
  const [ searchText, setSearchText ] = useState( null );
  const [ certificates, setCertificates ] = useState( null );
  const [ meta, setMeta ] = useState( null );
  const [ rowsPerPage, setRowsPerPage ] = useState( 10 );
  const [ filters, setFilters ] = useState( {
    statuses: []
  } );

  useEffect( () => {
    getCertificates( ( meta && meta.current_page ) ?? 1, sortField, sortDirection, searchText, filters );

    return () => {
      store.dispatch( hideNotification() );
    }
  }, [] ); // eslint-disable-line react-hooks/exhaustive-deps

  useUpdateEffect( () => {
    getCertificates( 1, sortField, sortDirection, searchText, filters );

    return () => {
      store.dispatch( hideNotification() );
    }
  }, [ filters ] ); // eslint-disable-line react-hooks/exhaustive-deps

  useUpdateEffect( () => {
    getCertificates( 1, sortField, sortDirection, searchText, filters );

    return () => {
      store.dispatch( hideNotification() );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ rowsPerPage ] );

  const getCertificates = (page, sortField, sortDirection, searchText,) => {
    const orderNumber = location.state?.orderNumber;
    const orderId = location.state?.orderId;

    const paginationOptions = {
      page: page,
      sort_by: sortField,
      sort: sortDirection,
      q: searchText,
      per_page: rowsPerPage,
      statuses: getCertificateStatusFilterIdentifiers(filters?.statuses),
      'order': orderId,
      page_context: PAGE_CONTEXTS.CERTIFICATES.LIST
    }

    api.getCertificatesApi( {
      pagination: paginationOptions,
      orderId: orderId,
      notificationId: NOTIFICATION_LIST_CERTIFICATES,
      hideNotification: hideNotification
    } ).then(
      response => {
        if (! response || ! response.data) {
          return;
        }

        setCertificates( response.data );
        if (orderNumber) {
          setSearchText( orderNumber )
          history.replace( location.pathname, {} )
        }

        setMeta( response.meta );
      }
    );
  }

  function applySort(appliedSortField) {
    let newSortDirection = "";

    if (sortField) {
      if (sortField === appliedSortField) {
        newSortDirection = sortDirection === "asc" ? "desc" : "asc";
      } else {
        newSortDirection = "asc";
      }
    } else {
      newSortDirection = "asc";
    }

    setSortField( appliedSortField );
    setSortDirection( newSortDirection );

    getCertificates( meta.current_page, appliedSortField, newSortDirection, searchText, true );

  }

  const applyFilters = (key, data) => {
    setFilters( {
      ...filters,
      [key]: data
    } );

  }

  const removeAllFilters = () => {
    setFilters( {
      statuses: [],
    } );
  }

  const removeFilter = item => {
    setFilters( {
      ...filters,
      [item.key]: filters[item.key].filter( elem => elem.identifier !== item.identifier )
    } );
  }

  return (
    <div className="certificates-list-layout">
      <ListToolbar
        activeFilters={(
          <FiltersList
            id="filters"
            filters={filters}
            filterList="certificates"
            onRemoveFilter={removeFilter}
            onRemoveAllFilters={removeAllFilters}
          />
        )}
        className="certificates-list-toolbar"
        filters={(
          <div className="certificates-list-filter">
            <span className="certificates-list-filter__label">
              <FormattedMessage id="components.pages.management.manageCertificates.status"/>
            </span>
            <CheckboxFilter
              index={0}
              applyFilters={applyFilters}
              filters={filters.statuses}
              filterKey={FILTERS.statuses}
              filterName={FILTERS_NAMES.statuses}
              list={TRANSLATED_CERTIFICATE_FILTER_STATUSES}
              type="button"
            />
          </div>
        )}
        search={(
          <Search
            search={searchText => {
              getCertificates( 1, null, null, searchText );
              setSearchText( searchText );
            }}
            searchText={searchText}
            id="certificates"
          />
        )}
        settings={(
          <AutoRefreshTable
            id="certificates"
            getData={getCertificates}
            sortDirection={sortDirection}
            sortField={sortField}
            searchText={searchText}
          />
        )}
      />
      <div className="certificates-list-table">
        <CertificatesTableComponent
          certificates={certificates}
          shouldRenderFields={true}
          applySort={sortField => applySort( sortField )}
          actionCallback={(useState) => {
            if (useState) {
              getCertificates(meta.current_page, sortField, sortDirection, searchText);
            } else {
              getCertificates();
            }
          }}
        />
      </div>
      <div className="certificates-list-pagination">
        <Paginator
          meta={meta}
          settings={(
            <RowsPerPage
              changeRowsPerPage={(rowsPerPage) => {
                setRowsPerPage( rowsPerPage );
              }}
              id="certificates"
            />
          )}
          changePage={page => getCertificates( page, sortField, sortDirection, searchText, true )}
        />
      </div>
    </div>
  )
}

const CertificatesTable = connect( null, {
  showSpinner,
  hideSpinner
} )( Certificates );

export { CertificatesTable, Certificates }
